import React from 'react'
import CustomSelect from './CustomSelect'

const ModalFilter = ({ListeAgents, ListPaySend, ListPayReceiv, ListeKYC, setForm, form, addTab, setShowFilterModal}) => {
  return (
    <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-3xl w-full max-w-md p-8 shadow-2xl">
            <h3 className="text-[24px] font-bold text-[#422EAE] mb-6 ">Nouvelle  Fenêtre </h3>
            
             <div className="space-y-6">
              <div className="flex flex-col items-start"  >
                <label className="text-[18px] text-left font-bold  text-[#422EAE]">Nom de la vue</label>
                <input id="tabName" type="text" placeholder="Ex: Clients VIP Sénégal" value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                  className="w-full border-[#AEB6FB] border-2 placeholder:text-[#AEB6FB] text-[#5754E5] rounded-xl p-3  h-[48px] focus:border-[#5754E5] outline-none text-[18px] " 
                />
              </div>
             

              <div className="grid grid-cols-2 gap-4 w-full">
                  <CustomSelect id="tabKyc" options={ListeKYC} value={form.kyc} placeholder='Tous' onChange={(val) => setForm({ ...form, kyc: val })} styleSlect='top-full' label='Statut KYC'/>
                  <CustomSelect options={ListeAgents} value={form.agent} placeholder='Tous' onChange={(val) => setForm({ ...form, agent: val })} styleSlect='top-full' label='Agent Name'/>
              </div>
              <div className="grid grid-cols-2 gap-4">
                  <CustomSelect options={ListPaySend} value={form.origin} placeholder='Tous' onChange={(val) => setForm({ ...form, origin: val })} styleSlect='top-full' label='Pays d’envoi'/>
                  <CustomSelect options={ListPayReceiv} value={form.dest} placeholder='Tous' onChange={(val) => setForm({ ...form, dest: val })} styleSlect='top-full' label='Pays de destination'/>
              </div>
              <label className="flex items-center gap-4 text-[#422EAE] font-bold text-[16px]"> Document send 
                <input className="w-[16px] h-[16px]  cursor-pointer  accent-[#5754E5] rounded-[14px] shadow-[0px_0px_0px_2px_#D1D1FF]" 
                type="checkbox"
                checked={form.doc || false}
                onChange={(e=> setForm({...form, doc: e.target.checked}))}
                /> 
              </label>
          
            </div>

            <div className="flex gap-3 mt-8">
              <button onClick={() => setShowFilterModal(false)} className="flex-1 h-[56px]  font-bold text-[16px] text-[#5754E5] border  border-[#5754E5] hover:border-[#4D36CC] hover:bg-[#F1F1FF] hover:text-[#4D36CC]  rounded-[16px]  transition-all">Annuler</button>
              <button 
              
                onClick={() => {
                  addTab({
                    name: form.name || "Vue filtrée",
                    kyc: form.kyc || undefined,
                    agent: form.agent || undefined,
                    origin: form.origin || undefined,
                    dest: form.dest || undefined,
                    doc: form.doc ? true : undefined
                  });
                }}
                className="flex-1 bg-[#5754E5] h-[56px] font-bold text-[16px] text-white rounded-[16px] shadow-lg  hover:bg-[#4D36CC] transition-all"
              >
                Créer la fenêtre
              </button>
            </div>
          </div>
        </div>
  )
}

export default ModalFilter
